import { render, staticRenderFns } from "./DeviceOta.vue?vue&type=template&id=01370628&"
import script from "./DeviceOta.vue?vue&type=script&lang=js&"
export * from "./DeviceOta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports